import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { EJType, useTypesTableContext } from '../../../../TypesTableContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useSoftRemoveEjTypeMutation } from 'schema'

export function useRemove(): RemoveRowActionOptions<EJType> {
  const { refetch } = useTypesTableContext()
  const [remove] = useSoftRemoveEjTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveEJType: {
        type: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    disabled: ({ judgements, users }) =>
      !!judgements.length || !!users.length
        ? {
            message:
              'Types cannot be deleted if they are associated with one or more Engineering Judgements or Users',
          }
        : false,
    permission: Permission.RemoveRestoreEJType,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
